import React, { Fragment } from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import { useTranslation } from "react-i18next";

export default function TextField(props) {
  const { errorText, validationSchema, ...rest } = props;
  const [field, meta] = useField(props);
  const { summaryMode } = rest;
  const { t } = useTranslation();
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;
  return (
    <Form.Group className={"text-area"}>
      {!summaryMode ? (
        <>
          {rest.label && (
            <Form.Label className="paragraph-small-fs9" htmlFor={field.name}>
              {rest.label}
            </Form.Label>
          )}
          <Fragment>
            <Form.Control
              type="text"
              name={field.name}
              placeholder={
                typeof rest.placeholder === "object"
                  ? t(rest.placeholder.props.i18nKey)
                  : rest.placeholder
              }
              value={field.value}
              onChange={field.onChange}
              as="textarea"
              className={
                meta.touched && meta.error ? "text-area is-invalid" : "text-area"
              }
              rows="5"
              aria-describedby={
                meta.touched && meta.error ? field.name + "-error" : null
              }
              required={isRequired}
              id={field.name}
            />
            {meta.touched && meta.error && (
              <p
                className="form-error-text paragraph-small-form"
                role="alert"
                id={field.name + "-error"}
              >
                {meta.error}
              </p>
            )}
          </Fragment>
        </>
      ) : (
        <>
          {rest.label && (
            <span className="paragraph-small-fs9">
              {rest.label}
            </span>
          )}
        <SummaryItem value={field.value} error={meta.error} />
        </>
      )}
    </Form.Group>
  );
}
